<template>
    <div>
        <div v-if="$route.path.indexOf('_editor') === -1">
            <el-row :gutter="20">
                <!-- <el-col :span="3">
                    <el-button type="primary" icon="plus" @click="descTemplate" style="width: 100%" size="mini">导出全部告知书</el-button>
                </el-col> -->
                <el-col :md="10" :lg="7">
                    <el-input placeholder="姓名" size="small" v-model="params.realname"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
                <el-col :md="10" :lg="7">
                    <el-input placeholder="手机号" size="small" v-model="params.mobile"><el-button slot="append" icon="el-icon-search" @click="search"></el-button></el-input>
                </el-col>
            </el-row>
            <el-tabs v-model="activeName" type="border-card">
                <el-tab-pane v-for="(item, index) in tabList" :key="index" :label="item.name" :name="item.activeName">
                    <el-table :data="ItemsList" style="width: 100%"  v-loading="loading">
                        <el-table-column prop="healthy_id" label="报告id" width="70"></el-table-column>
                        <el-table-column prop="username" label="昵称" width="120" ></el-table-column>
                        <el-table-column prop="realname" label="真实姓名" width="120" ></el-table-column>
                        <el-table-column prop="mobile" label="手机号" width="120" ></el-table-column>
                        <el-table-column prop="user_id" label="用户ID" width="120" ></el-table-column>
                        <el-table-column prop="inform" label="告知书" width="100" >
                            <template slot-scope="scope">
                                <a :href="scope.row.inform" target="_blank" download>下载</a>
                            </template>
                        </el-table-column>
                        <el-table-column prop="push_np" label="推送np" width="120" ></el-table-column>
                        <el-table-column prop="created_at" label="填写时间">
                            <template slot-scope="scope">{{scope.row.created_at|datetime('yyyy-MM-dd hh:mm:ss')}}</template>
                        </el-table-column>
                        <el-table-column prop="use_time" label="使用时长" width="90" >
                            <template slot-scope="scope">
                            <el-tag size="mini" effect="plain" type="success" v-for="(v,k) in UseTime" :key="index" v-if="scope.row.use_time==v.value">{{v.name}}</el-tag>
                            </template>
                            <!--<template slot-scope="scope">-->
                                <!--<el-switch v-model="scope.row.is_record"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchRecord(scope.$index, scope.row)"></el-switch>-->
                            <!--</template>-->
                        </el-table-column>
                        <el-table-column prop="feel_use" label="使用感受" width="90" >
                            <template slot-scope="scope">
                            <el-tag size="mini" effect="plain" type="success" v-for="(v,k) in UseFeel" :key="index" v-if="scope.row.feel_use==v.value">{{v.name}}</el-tag>
                            </template>
                            <!--<template slot-scope="scope">-->
                                <!--<el-switch v-model="scope.row.is_record"  active-value="1" inactive-value="0" active-color="#13ce66"  inactive-color="#ff4949" @change="switchRecord(scope.$index, scope.row)"></el-switch>-->
                            <!--</template>-->
                        </el-table-column>
                        <el-table-column label="操作">
                            <template slot-scope="scope">
                              <div class="operating-icons">
                                <i class="mark iconfont icon-trash-alt1" @click="deleteAction(scope.$index, scope.row)"></i>
                              </div>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-tab-pane>
            </el-tabs>
        </div>
        <router-view></router-view>
        <div class="content-center content-top-padded">
            <el-pagination
                    background
                    layout="total, sizes, prev, pager, next"
                    @current-change="handleCurrentChange"
                    @size-change="handleSizeChange"
                    :current-page.sync="params.page"
                    :page-sizes="[10,20,50]"
                    :total="total_count"
                    :page-size="params.pageSize">
            </el-pagination>
        </div>
       
       
        
    </div>
</template>
<script>
    import { mapGetters } from 'vuex'
   
    import { 
        Inform as getList,
        InformPdfs,
    } from '../../api/member'
    import sideBar from '@/components/element/sideBar'
    export default {
        components: {
          sideBar
        },
        props: {
          distributorId: {
            type: String,
            default: ''
          },
          isLoad: {
            type: Boolean,
            default: false
          }
        },
        data () {
            return {
                status:'',
                loading:true,
                exportloading: false,
                tabList: [
                    {name: "列表", value: null, activeName: 'first'},
                    // {name: "待审核", value: 'true', activeName: 'second'},
                ],
                activeName: 'first',
                ItemsList: [],
                params: {
                    page: 1,
                    pageSize: 20,
                    realname:'',
                    mobile:'',
                },
                UseTime: [
                    { name: '1年以下', value: 1 },
                    { name: '1-3年', value: 2 },
                    { name: '3年以上', value: 3 },
                ],
                UseFeel: [
                    { name: '非常好', value: 1 },
                    { name: '一般', value: 2 },
                    { name: '有待改进', value: 3 },
                ],
                healthy_id:0,
                total_count:0,
            }
        },
        computed: {
            ...mapGetters([
                'wheight'
            ])
        },
        methods: {
            
            handleCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            // descTemplate () {
            //     InformPdfs()
            // },
            
            handleSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            handleGoodsDialogCurrentChange (page_num) {
                this.params.page = page_num
                this.getList()
            },
            handleGoodsDialogSizeChange (pageSize) {
                this.params.page = 1
                this.params.pageSize = pageSize
                this.getList()
            },
            
            handleGoodsDialogCancel(){
                this.goodsDialog.goodsVisible = false
            },
            
            search () {
                this.params.page = 1
                this.getList()
            },
            deleteAction (index, row) {
        
                this.$confirm('此操作将删除数据, 是否继续?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {

                  InformPdfs(row.healthy_id).then(response => {
                    
                    this.ItemsList.splice(index, 1)
                    this.$message({
                      message: '删除成功',
                      type: 'success',
                      duration: 5 * 1000
                    })
                  }).catch(() => {
                    this.$message({
                      type: 'error',
                      message: '删除失败'
                    })
                  })
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消'
                  })
                })
            },
            getList () {
                this.loading = true
                getList(this.params).then(response => {
                    this.ItemsList = response.data.data.list
                    this.total_count = response.data.data.total_count
                    this.warning_store = response.data.data.warning_store
                    this.loading = false
                })

            },
            
            
           
            
            
           

        },
        mounted () {
            
            this.params = this.$route.query
            this.getList()
        },
        watch: {
            getStatus (val) {
                if (val) {
                    this.getList()
                }
            },
            $route(){
                this.getList()
            }
        }
    }

</script>
<style>
    .goods-popover-img{
        margin-top: 5px;
        margin-bottom: 5px;
        background:#000;
        border:1px solid #fff;
        border-width:5px 5px 5px 5px;
        box-shadow:1px 1px 5px #333;
        -webkit-box-shadow:1px 1px 5px #333;
        -moz-box-shadow:1px 1px 5px #333;
    }
</style>



// WEBPACK FOOTER //
// inform.vue?b90122fc